import { render, staticRenderFns } from "./SearchProductCategoriesMobile.vue?vue&type=template&id=1be3a920&"
import script from "./SearchProductCategoriesMobile.vue?vue&type=script&lang=js&"
export * from "./SearchProductCategoriesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports